import { types } from "../types/types";

export const getAsientosSearchFilter = (values) => ({
  type: types.getAsientosSearchFilter,
  payload: values,
});

export const importAsientosSearchFilter = (state) => {
  return async (dispatch) => {
    dispatch(getAsientosSearchFilter(state));
  };
};
